export const INSIDER_TRANSACTIONS_TABLE_COLUMNS = [
  {
    key: 'name',
    title: 'Insider’s Name',
  },
  {
    key: 'title',
    title: 'Insider’s Title',
  },
  {
    key: 'date',
    title: 'Transaction Date',
    sort: true,
  },
  {
    key: 'filingDateFormatted',
    title: 'Filing Date',
    sort: true,
  },
  {
    key: 'transactionType',
    title: 'Transaction',
    sort: true,
  },
  {
    key: 'transactionInfoType',
    title: 'Type',
    sort: true,
  },
  {
    key: 'pricePerShare',
    title: 'Price per Share',
    rightAligned: true,
  },
  {
    key: 'valueFormatted',
    title: 'Value',
    sort: true,
    rightAligned: true,
  },
];

export default INSIDER_TRANSACTIONS_TABLE_COLUMNS;
